export default __webpack_public_path__ + "static/media/pokemon_go_icon_display.2939d3f5.png";